import { useQuery, useQueryClient } from '@tanstack/react-query'
import Pet from '~models/pet'
import AppDataRepository from '~repositories/impl/app-data-repository'
import { APP_QUERY_KEYS } from './query-keys'

const usePetKinds = (selectedPetKind: string | null) => {
  const queryClient = useQueryClient()
  const queryKey = APP_QUERY_KEYS.petKinds

  return useQuery<Pet.Kind[], Error>({
    queryKey,
    queryFn: AppDataRepository.getPetKinds,
    initialData: () => queryClient.getQueryData<Pet.Kind[]>(queryKey),
    staleTime: Infinity,
    gcTime: Infinity,
    select: res => {
      const isPetKindSelected = !!selectedPetKind

      if (isPetKindSelected) {
        return res.filter(({ depth1, depth2 }) => depth1 === selectedPetKind && !!depth2)
      }

      return []
    },
  })
}

export default usePetKinds
